import { Component, OnInit } from '@angular/core';
import { IUsuarios } from '../interfaces/Usuarios';
import { Router } from '@angular/router';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import Swal from 'sweetalert2';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { IMarcas } from '../interfaces/Marcas';
import { IEdificios } from '../interfaces/Edificios';
import { filterPage, PagedResult } from '../interfaces/PagedResult';
import { PageEvent } from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-maestro-usuario',
  templateUrl: './maestro-usuario.component.html',
  styleUrls: ['./maestro-usuario.component.css']
})
export class MaestroUsuarioComponent implements OnInit {

  usuarios: IUsuarios[];
  term: string = "";
  search: string  = "";
  length !:number
  pageSize = 5
  pageSizeOptions = [5, 10, 25, 100];
  pageIndex = 0
  paged!:PagedResult<IUsuarios>

  constructor(private router: Router,
    private registroServicios: RegistroVentasService,
    private spinner: NgxSpinnerService,) { }

  ngOnInit(): void {
    this.cargarUsuarios();   
  }



  cargarUsuarios(){
    this.spinner.show();
    let filter : filterPage = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      search: this.term
    }
    this.registroServicios.obtenerUsuarios(filter).subscribe(
      resolve => {
        this.paged = resolve
        if (resolve.items != null) {
          this.usuarios = resolve.items;
          this.length = resolve.totalItems
          this.pageSize = resolve.pageSize;
          this.pageIndex = resolve.pageIndex
        }    
        else
        {
          Swal.fire({
            icon: 'error',
            title: 'Acceso Denegado...',
            text: 'Valide su usuario y contraseña'
          })
        }
        this.spinner.hide();
        },
        (error: ErrorResponse) => {
          console.log(error);
        }
      );
  }

  addUser(){
    this.router.navigate(['/home/registro/addUser']);
  }

  
  editUser(user: IUsuarios ){
    window.sessionStorage.removeItem("editUserId");
    window.sessionStorage.setItem("editUserId", user.identificacion.toString());
    this.router.navigate(['/home/registro/editUser']);
  }

  deleteUser(user: IUsuarios): void {
    Swal.fire({
      title: 'Esta seguro de eliminar este usuario?',
      text: "No podrás revertir los cambios!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, eliminar!'
    }).then((result) => {
      if (result.value) {
        this.registroServicios.deleteUser(user.identificacion)
          .subscribe( data => {
            this.usuarios = this.usuarios.filter(u => u !== user);
          }),
        Swal.fire(
          'Eliminado!',
          'El usuario fue eliminado.',
          'success'
        )
      }
    })

   
  };
changePage(pageEvent:PageEvent){
    this.pageSize = pageEvent.pageSize
    this.pageIndex = pageEvent.pageIndex
    this.cargarUsuarios()
  }
  cleanSearch(){
    this.term = ""
    this.cargarUsuarios()
  }

}
